export default __webpack_public_path__ + "static/media/img_03.b824e553.jpg";